import { Component, OnInit, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'cancel-policies',
    templateUrl: './cancel-policies.component.html',
    styleUrls: ['./cancel-policies.component.scss'],
    standalone: true,
    imports: [CardInfoDetailV2Component, NgIf],
})
export class CancelPoliciesComponent implements OnInit {
  @Input() countryId: string;
  @Input() isDisney: boolean;

  public isUSA = false;
  viewLess = true;

  ngOnInit() {
    this.isUSA = ['1128398', 'NEW201'].includes(this.countryId);
  }

  onClickViewMoreLess(viewLess) {
    this.viewLess = viewLess;
  }
}
